export default "__VITE_ASSET__DJBN$M0o__"